import {FC, useEffect, useRef, useState} from "react";
import Card from "../../components/ui/Card";
import {ILog} from "../../types/ApiTypes";
import LogsList from "../../components/admin/logs/LogsList";
import useApi from "../../hooks/useApi";
import Loading from "../../components/Loading";

const Logs: FC = () => {
    const mounted = useRef(false);
    const [logs, setLogs] = useState<ILog[]>([]);
    const [loading, setLoading] = useState(false);
    const {fetchSystemLogs} = useApi();

    useEffect(() => {
        mounted.current = true;
        return () => {mounted.current = false}
    },[])

    useEffect(() => {
        setLoading(true);
        fetchSystemLogs().then(res => {
            if(res && mounted.current) setLogs(res);
        }).finally(() => mounted.current && setLoading(false))
    },[fetchSystemLogs])

    return (
        <Card>
            {!loading && <LogsList logs={logs}/>}
            {loading && <Loading small/> }
        </Card>
    );
};

export default Logs;